import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();

export default async function getCompanies() {
	let companies = [];
	await firebaseRef.ref('/kavtek_companies/').once('value', (snapshot) => {
		let companyParent = snapshot.val();
		if (companyParent) {
			for (let key in companyParent) {
				companies.push({
					id: key,
					companyName: companyParent[key].companyName,
				});
			}
		}
	});
	return companies;
}
